import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import * as SettingSelector from '../../../../store/setting/selectors';
import Verticalnav from './verticalnav';
import Scrollbar from 'smooth-scrollbar';

const Sidebar = ({ isRTL }) => {
    const sidebarType = useSelector(SettingSelector.sidebar_type); // array
    const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style);

    useLayoutEffect(() => {
        const sidebarResponsive = document.querySelector('[data-sidebar="responsive"]');

        const handleResize = () => {
            const tabs = document.querySelectorAll('.nav');
            if (window.innerWidth < 1025) {
                Array.from(tabs, (elem) => {
                    if (!elem.classList.contains('flex-column')) {
                        elem.classList.add('flex-column', 'on-resize');
                    }
                });
                if (sidebarResponsive && !sidebarResponsive.classList.contains('sidebar-mini')) {
                    sidebarResponsive.classList.add('sidebar-mini', 'on-resize');
                }
            } else {
                Array.from(tabs, (elem) => {
                    elem.classList.remove('flex-column', 'on-resize');
                });
                if (sidebarResponsive) {
                    sidebarResponsive.classList.remove('sidebar-mini', 'on-resize');
                }
            }
        };

        // Run once on mount to set initial state
        handleResize();

        // Initialize scrollbar
        Scrollbar.init(document.querySelector('.data-scrollbar'));

        // Attach event listener
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <aside dir={isRTL ? "rtl" : "ltr"} className={`${sidebarType.join(" ")} ${sidebarMenuStyle} sidebar sidebar-default sidebar-base navs-rounded-all`} 
            id="first-tour" 
            data-toggle="main-sidebar" 
            data-sidebar="responsive">
            <div className="sidebar-body pt-0 data-scrollbar" >
                <div className="sidebar-list" style={{overflowX:"hidden"}}>
                    <Verticalnav />
                </div>
            </div>
            <div className="sidebar-footer"></div>
        </aside>
    );
};

export default Sidebar;
